exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.close-side-bar[data-v-7bb4938d]{position:relative;top:-8px;left:48px;cursor:pointer\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/shipper/src/components/common/Sidebar.vue"],"names":[],"mappings":";AACA,iCAAiC,kBAAkB,SAAS,UAAU,cAAc;CACnF","file":"Sidebar.vue","sourcesContent":["\n.close-side-bar[data-v-7bb4938d]{position:relative;top:-8px;left:48px;cursor:pointer\n}"],"sourceRoot":""}]);

// exports
